import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=22c27ac8&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"
import style0 from "./Download.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports